<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Tabela de Bancos</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{ countFilter }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Bancos</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" :class="window.width < 1880 ? 'dropleft' : ''">
                    <button class="btn btn-outline-secondary dropdown-toggle-ellipsis" id="dropdownMenuButton"
                      type="button" v-b-tooltip.hover.right title="Mais opções" 
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div class="dropdown-menu" id="dropTableOptions" aria-labelledby="dropdownMenuButton">
                      <a class="dropdown-item" href="#" :class="loadingList ? 'disabled' : ''" 
                         v-on:click.stop="ReportBank()">
                        <template v-if="loadingList">
                          <loader :small="true" :isLoading="loadingList"/>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Bancos</th>
                    <th scope="col" class="border-0">Código</th>
                    <th scope="col" class="border-0">ISPB</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(bank, index) in banks" :key="index">
                    <td></td>
                    <td class="text-left">{{ bank.Name }}</td>
                    <td>{{ bank.Code }}</td>
                    <td>{{ bank.ISPB }}</td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            v-if="$isAuthorize('Bank', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenBank($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('Bank', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenBank($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="$isAuthorize('Bank', 'Delete')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="ConfirmDeleteBank(bank.Name, bank.Id)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="banks == undefined || banks == null || banks.length == 0">
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal size="sm" id="mFormBank" :title="modalTitle" :no-close-on-backdrop="true" :no-close-on-esc="false">
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <!-- Name -->
        <ValidationObserver tag="form" ref="validatedBankForm">
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Banco</label>
              <ValidationProvider rules="required|min:3" v-slot="{ errors, invalid }">
                <d-form-input
                  type="text"
                  v-model="infoBank.Name"
                  :class="validatedBankForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                />
                <div class="invalid-feedback d-block" v-if="validatedBankForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <!-- Code -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Código</label>
              <ValidationProvider rules="required|min:2" v-slot="{ errors, invalid }">
                <d-form-input
                  type="text"
                  v-model="infoBank.Code"
                  :class="validatedBankForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                />
                <div class="invalid-feedback d-block" v-if="validatedBankForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <!-- ISPB -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>ISPB</label>
              <ValidationProvider rules="required|min:8|max:10" v-slot="{ errors, invalid }">
                <d-form-input
                  type="text"
                  v-model="ISPB"
                  :class="validatedBankForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                />
                <div class="invalid-feedback d-block" v-if="validatedBankForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveBank()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal id="mFilter" title="Filtros" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <d-form-row>
        <d-col md="6" class="form-group">
          <input placeholder="Banco" type="text" class="form-control" v-model="filter.Name" v-on:keyup.enter="Filter()" />
        </d-col>
        <d-col md="6" class="form-group">
          <input placeholder="Code" type="text" class="form-control" v-model="filter.Code" v-on:keyup.enter="Filter()" />
        </d-col>
        <d-col md="6" class="form-group">
          <input placeholder="ISPB" type="text" class="form-control" v-model="filter.ISPB" v-on:keyup.enter="Filter()" />
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button variant="primary" class="btn btn-primary" v-b-tooltip.hover.bottom title="Pesquisar" @click="Filter()">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('Bank', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo banco"
      v-on:click="OpenBank($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import dateField from "../common/date-field";
import { hasValue } from "../../utils/functions.js";
export default {
  name: "banks",
  data: function() {
    return {
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      modalTitle: "Novo banco",
      countFilter: 0,
      filter: {
        Name: null,
        Code: null,
        ISPB: null
      },
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      idBank: 0,
      pOpened: null,
      banks: [],
      infoBank: {
        Name: null,
        Code: null,
        ISPB: null
      },
      isSeeing: false,
      validatedBankForm: false,
      window: {
        width: 0,
        height: 0
      },
    };
  },
  components: {
    dateField
  },
  computed: {
    ISPB: {
      get() {
        return this.infoBank.ISPB;
      },
      set(newValue) {
        const regExp = new RegExp(/[\D]/g);//Detect non-numbers
        if(newValue != null && this.infoBank.ISPB != newValue && !regExp.test(newValue)){
          this.infoBank.ISPB = newValue;
        }
      }
    }
  },
  watch: {
    "pagination.PageNumber": function() {
      this.BankList();
    },
    "pagination.RowsPerPage": function() {
      this.BankList();
    }
  },
  mounted() {
    this.BankList();
  },
  methods: {
    OpenBank: function(e, i, view) {
      e.preventDefault();
      this.validatedBankForm = false;
      this.ResetInfoBank();

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.idBank = this.banks[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar banco";
        this.GetBank();
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.ResetInfoBank;
        this.isSeeing = false;
        this.modalTitle = "Banco";
        this.ResetInfoBank();
      } else {
        // View
        this.pOpened = i;
        this.idBank = this.banks[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do Banco";
        this.GetBank();
      }
      this.$bvModal.show("mFormBank");
    },
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.BankList();
    },
    ResetFilter: function() {
      this.filter = {
        Name: null,
        Code: null,
        ISPB: null
      };
      this.BankList();
    },
    ResetInfoBank: function() {
      this.infoBank = {
        Name: null,
        Code: null,
        ISPB: null
      };
    },
    SaveBank: function() {
      this.validatedBankForm = true;

      this.$refs.validatedBankForm.validate().then(isValid => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            this.$store.dispatch("AddBank", this.infoBank)
              .then(() => {
                this.$makeToast("O Banco foi cadastrado com sucesso.", "success", "Banco cadastrado");
                this.BankList();
                this.$bvModal.hide("mFormBank");
              })
              .catch(error => {
                this.$makeToast(undefined, "danger", "Erro ao cadastrar o Banco", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.$store.dispatch("UpdateBank", this.infoBank)
              .then(() => {
                this.$makeToast("O Banco foi atualizado com sucesso.", "success", "Banco atualizado");
                this.BankList();
                this.$bvModal.hide("mFormBank");
              })
              .catch(error => {
                this.$makeToast(undefined, "danger", "Erro ao atualizar o Banco", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetParamsBank(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Name": this.filter.Name,
        "Object.Code": this.filter.Code,
        "Object.ISPB": this.filter.ISPB
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },
    GetBank: function() {
      if (this.idBank != 0) {
        this.loadingModal = true;
        this.$store.dispatch("GetBank", { id: this.idBank })
          .then(response => {
            this.infoBank = response;
          })
          .catch(error => {
            this.$makeToast(undefined, "danger", "Erro ao carregar o Banco", error);
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    BankList: function() {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Code)) this.countFilter++;
      if (hasValue(this.filter.ISPB)) this.countFilter++;
      this.loadingList = true;
      const data = this.GetParamsBank();
      this.$store.dispatch("BankList", { params: data })
        .then(response => {
          this.banks = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar os Bancos", error);
        })
        .finally(() => (this.loadingList = false));
    },
    ConfirmDeleteBank: function(description, id) {
      this.$makeMsgBox("Você tem certeza que deseja remover " + description + " ?", "Confirmar", this.DeleteBank, id);
    },
    DeleteBank: function(id) {
      this.loadingList = true;
      this.$store.dispatch("DeleteBank", { id: id })
        .then(() => {
          this.$makeToast("O banco foi removido com sucesso.", "success", "Banco removido");
          this.BankList();
          this.$bvModal.hide("mFormBank");
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao remover o Banco", error);
        })
        .finally(() => (this.loadingList = false));
    },
    ReportBank() {
      this.loadingList = true;
      const params = this.GetParamsBank(true);
      this.$store.dispatch("BankReport", { params })
        .then(response => {
          if (hasValue(response.UrlReport)) {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingList = false;
          }, 1200);
        });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/banks.vue